import React, { Component } from "react";

class WriterModeTimer extends Component {
  formatTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    }

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  render() {
    const { secondsLeft, timerRunning, timerPhase = 'work', onStart, disabled = false, className = '' } = this.props;
    const isRestPhase = timerPhase === 'rest';
    const isReflectionPhase = timerPhase === 'reflection';
    // Show rest glow when running in rest phase, purple when running work phase, otherwise idle glow
    const glowClass = isRestPhase && timerRunning
      ? ' writer-mode-timer--rest-glow'
      : timerRunning
      ? ' writer-mode-timer--running'
      : disabled ? '' : (isRestPhase ? ' writer-mode-timer--rest-glow' : ' writer-mode-timer--idle-glow');
    const timerClassName = `writer-mode-timer${glowClass}${disabled ? ' writer-mode-timer--disabled' : ''}${isRestPhase ? ' writer-mode-timer--rest' : ''}${className ? ` ${className}` : ''}`;

    return (
      <button
        type="button"
        className={timerClassName}
        role="timer"
        aria-live="polite"
        onClick={onStart}
        disabled={timerRunning || disabled}
      >
        <span className="writer-mode-timer-value">{this.formatTime(secondsLeft)}</span>
        <span>
          {timerRunning ? "Running" : isRestPhase ? "Break" : isReflectionPhase ? "Reflecting" : "Start"}
        </span>
      </button>
    );
  }
}

export default WriterModeTimer;
